import axios from 'axios';
import * as Raven from 'raven-js';

const { Ridi: { globals: { accountApiUrl, oauth2_client_id } } } = window;

class AxiosSingleton {
  static instance;

  static getInstance() {
    const instance = AxiosSingleton.instance
      ? AxiosSingleton.instance
      : (AxiosSingleton.instance = axios.create({ withCredentials: true, timeout: 30000 }));
    return instance;
  }
}

export const makeLoginURI = (authorizeURI, clientId, redirectURI) => `${authorizeURI}?client_id=${clientId}&response_type=code&redirect_uri=${redirectURI}`;

export const requestRefreshToken = (instance, originalError) => instance
  .post(`${accountApiUrl}/ridi/token/`, null, { withCredentials: true })
  .then(() => instance(originalError.response.config))
  .catch(error => {
    const currentURI = makeLoginURI(
      `${accountApiUrl}/ridi/authorize/`,
      oauth2_client_id,
      window.location.href,
    );
    window.location.href = currentURI;
    return Promise.reject(error);
  });

export const requestCreateToken = (instance, originalError) => axios
  .get(`${accountApiUrl}/ridi/authorize/`, {
    withCredentials: true,
    params: {
      client_id: oauth2_client_id,
      response_type: 'code',
      redirect_uri: `${accountApiUrl}/ridi/complete`,
    },
  })
  .then(() => instance(originalError.response.config)) /* for rest xhr request */
  .catch(error => {
    if (error.response && error.response.status !== 401) {
      Raven.captureException(error, {
        tags: {
          api: 'account',
          action: 'oauth',
        },
      });
    }
    return Promise.reject(error);
  });

export const createAxiosWithOauth2Handling = () => {
  const instance = AxiosSingleton.getInstance();
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        if (error.response.config.url !== `${accountApiUrl}/ridi/token/`) {
          return requestRefreshToken(instance, error);
        }
        return requestCreateToken(instance, error);
      }
      return Promise.reject(error);
    },
  );
  return instance;
};

export const accountsMeWithRefresh = () => createAxiosWithOauth2Handling().get(`${accountApiUrl}/accounts/me`, {
  withCredentials: true,
}).then(res => res.data);

export const accountsMe = () => axios.get(`${accountApiUrl}/accounts/me`, {
  withCredentials: true,
}).then(res => res.data);



// WEBPACK FOOTER //
// ./util/authHelper.js